import React from 'react';
import { painPoints } from '../data/content';
export function PainPoints() {
  return <section className="bg-concrete-900 py-16 sm:py-20" aria-labelledby="dolor" data-id="element-144" data-mp="2ln2ee50o55nw">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-145" data-mp="26yfrni8ppbmn">
        <h2 id="dolor" className="font-display text-3xl uppercase leading-none text-concrete-50 sm:text-5xl" data-id="element-146" data-mp="26xmpyvom1cbd">
          La neta, hermano... <span className="text-safety" data-id="element-147" data-mp="1xxzsum2wyso4">¿te suena esto?</span>
        </h2>

        <ul className="mt-10 divide-y divide-concrete-700 border-y border-concrete-700" data-id="element-148" data-mp="1y0427jjl0jvs">
          {painPoints.map(item => <li key={item.text} className="flex gap-5 py-6" data-id="element-149" data-mp="1o03elleojhls">
              <span className="text-2xl leading-none sm:text-3xl" aria-hidden="true" data-id="element-150" data-mp="1o1o95b0zv0jn">
                {item.emoji}
              </span>
              <p className="text-lg leading-relaxed text-concrete-200 sm:text-xl" data-id="element-151" data-mp="3id3549kllw7u">
                {item.text}
              </p>
            </li>)}
        </ul>

        <p className="mt-10 max-w-3xl border-l-4 border-safety pl-5 font-display text-xl uppercase leading-tight text-concrete-50 sm:text-3xl" data-id="element-152" data-mp="3nabmi7xx9w81">
          Si quieres dejar de ser el que carga los bultos y empezar a ser el que
          firma los cheques, necesitas un{' '}
          <span className="text-safety" data-id="element-153" data-mp="27s778xre8179">sistema</span>, no solo una cuchara.
        </p>
      </div>
    </section>;
}